<template>
  <v-container>
    <loader :isLoading="isLoading"></loader>
    <!-- <loader :isLoading="isGenerating"></loader> -->
    <!-- <form-component
      :formData="formData"
    >
    </form-component> -->
    <form-component
     ref="form"
     :formData="formData"
    >
    <!-- FREEZER UI -->
      <template #freezer-ui-section>
        <div class="generate-button">
          <v-progress-circular
            v-if="isGenerating"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn
            v-else
            @click="generateFreezerUi()"
            color='primary'
            depressed
            clearable
            :disabled="!displayGenButton"
          >
           {{ generatedUi ? 'Regenerate' : 'Generate' }}
          </v-btn>
        </div>
        <div v-if="generatedUi && !isGenerating">
          <div class="freezerUi">
            <div
              class="shelf-wrapper"
              v-for="shelf in shelves"
              :key="shelf.shelfNo"
            >
              <!-- HEADER -->
              <div class="shelf-header">
                <div class="shelf-title">
                  Shelf {{ shelf.shelfNo }}
                </div>

                <div class="shelf-controls">
                  <v-text-field
                    v-model="shelf.noOfColumn"
                    type="number"
                    label="Columns"
                    outlined
                    dense
                    hide-details
                    min="1"
                    max="5"
                    class="column-input"
                    :rules= "[
                      (v) => !!v || 'No of Column is required',
                      (v) => Number.isInteger(Number(v)) || 'Must be a whole number', (v) => v >= 1
                      || 'Minimum is 1 column', (v) => v <= 5
                      || 'Maximum is 5 columns'
                    ]"
                  />

                  <v-btn
                    color="primary"
                    depressed
                    small
                    :loading="shelf.isGeneratingColumn"
                    @click="generateColumn(shelf)"
                    :disabled="
                      shelf.noOfColumn > 5
                      || shelf.noOfColumn < 1
                      || shelf.contents.length === Number(shelf.noOfColumn)
                    "
                  >
                    {{ shelf.contents.length ? 'Regenerate' : 'Generate' }}
                  </v-btn>
                </div>
              </div>

              <!-- SHELF BODY -->
              <div
                class="shelf-body"
                :style="{
                  gridTemplateColumns: `repeat(${shelf.contents.length}, 1fr)`
                }"
              >
                <div
                  v-for="content in shelf.contents"
                  :key="content.columnNo"
                  class="freezer-column"
                >
                  <!-- COLUMN HEADER -->
                  <div class="column-label">
                    <span>
                      Column {{ content.columnNo }}
                    </span>

                    <v-btn
                      icon
                      x-small
                      color="red"
                      @click.stop="removeColumn(shelf, content.columnNo)"
                    >
                      <v-icon small>
                        mdi-delete-outline
                      </v-icon>
                    </v-btn>
                  </div>

                  <!-- COLUMN CONTENT -->
                  <div class="column-content">

                    <div
                      v-if="content.type && content.type.toLowerCase() !== 'empty'"
                      class="column-form-wrapper"
                    >
                      <!-- TOP ICON -->
                      <div class="column-form-header">
                        <v-icon
                          size="34"
                          :color="getColumnColor(content.type)"
                        >
                          {{ getColumnIcon(content.type) }}
                        </v-icon>

                        <div class="column-form-title">
                          {{ content.type }}
                        </div>
                      </div>

                      <!-- FORM -->
                      <v-form class="column-form" fast-fail @submit.prevent>

                        <v-text-field
                          v-if="content.type.toLowerCase() === 'rack'"
                          v-model="content.slidingRacksNo"
                          label="Sliding Racks"
                          outlined
                          dense
                          hide-details="auto"
                          prepend-inner-icon="mdi-view-carousel"
                          class="mb-3"
                          :rules="[
                            (v) => !!v || 'Sliding Racks is required'
                          ]"
                        />

                        <v-text-field
                          v-model="content.name"
                          label="Content Name"
                          outlined
                          dense
                          hide-details="auto"
                          prepend-inner-icon="mdi-tag-outline"
                          class="mb-3"
                        />

                        <v-textarea
                          v-model="content.notes"
                          clearable
                          label="Notes"
                          outlined
                          dense
                          auto-grow
                          rows="3"
                          hide-details="auto"
                          prepend-inner-icon="mdi-note-text-outline"
                          class="scrollable-textarea"
                        />

                      </v-form>
                    </div>
                    <div v-else>
                      <!-- ICON -->
                      <v-icon
                        size="55"
                        :color="getColumnColor(content.type)"
                      >
                        {{ getColumnIcon(content.type) }}
                      </v-icon>

                      <!-- TYPE -->
                      <div class="column-type">
                        {{ content.type || 'Unassigned' }}
                      </div>
                    </div>

                    <!-- SELECT -->
                    <div class="column-select">
                      <v-select
                        v-model="content.type"
                        :items="storageTypes"
                        item-text="label"
                        item-value="value"
                        label="Storage Type"
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-database"
                        @change="onStorageTypeChange(content)"
                      >
                        <template v-slot:item="{ item }">
                          <v-list-item-icon>
                            <v-icon :color="item.color">
                              {{ item.icon }}
                            </v-icon>
                          </v-list-item-icon>

                          <v-list-item-content>
                            <v-list-item-title>
                              {{ item.label }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </v-select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #description-section>
          <v-textarea
            v-model="formData.freezerDescription.value"
            :name="formData.freezerDescription.name"
            :counter="formData.freezerDescription.counter"
            :label="formData.freezerDescription.label"
            :placeholder="formData.freezerDescription.placeholder"
            :maxlength="formData.freezerDescription.maxlength"
            outlined
            dense
            clearable
          >
          </v-textarea>
      </template>

    <!-- add save button here -->
      <template #save-button-section>
        <v-btn
            style="margin-top: 20px;"
            color='primary'
            depressed
            clearable
            type="button"
            @click="onSave()"
          >
            Save
        </v-btn>
      </template>
    </form-component>
  </v-container>
</template>

<script>
import Loader from '../../../components/utilities/Loader.vue';
// import WidgetComponent from '../../../components/ui/WidgetComponent.vue';
import FormService from '../../../services/medical_registry/form.service';
import FormComponent from '../../../components/ui/FormComponent.vue';

export default {
  name: 'FreezerForm',
  components: {
    FormComponent,
    Loader,
    // WidgetComponent,
  },
  props: {
    onSubmit: Function,
    isLoading: Boolean,
    freezer: Object,
  },
  data() {
    return {
      FormService,
      countAddedBox: 4,
      // storeBoxes: [],
      displayGenButton: false,
      shelfNumber: 0,
      isGenerating: false,
      generatedUi: false,
      displayShelf: 0,
      displayRacks: 0,
      shelves: [],
      racksInput: [],
      racks: [],
      // {
      //   name: 'rackInput01',
      //   shelfNo: 'shelfNo1',
      // }
      // shelf: {
      //   shelfNo: 0,
      //   type: null,
      //   racks: [],
      // },
      // racks: {
      //   rackNo: 0,
      //   noOfSlidingRacks: 0,
      // },
      storageTypes: [
        {
          label: 'Rack',
          value: 'Rack',
          icon: 'mdi-view-stream',
          color: 'primary',
        },
        {
          label: 'Box',
          value: 'Box',
          icon: 'mdi-package-variant-closed',
          color: 'orange',
        },
        {
          label: 'Others',
          value: 'Others',
          icon: 'mdi-dots-horizontal-circle-outline',
          color: 'purple',
        },
        {
          label: 'Empty',
          value: 'Empty',
          icon: 'mdi-close-circle-outline',
          color: 'grey',
        },
      ],
      formData: {
        onSubmit: this.onSubmit,
        model: this.freezer,
        freezerDescription: {
          type: 'textarea',
          name: 'description',
          label: 'Description',
          value: '',
          counter: 255,
          maxLength: 255,
          rules: [
            (v) => !!v || 'Description is required',
          ],
        },
        noOfRacks: {
          type: 'number',
          name: 'noOfRacks',
          label: 'Number of Racks',
          value: '',
          counter: 100,
          maxLength: 100,
          min: 1,
          max: 5,
          rules: [
            (v) => !!v || 'No of Racks is required',
            (v) => Number.isInteger(Number(v)) || 'Must be a whole number',
            (v) => v >= 1 || 'Minimum is 1 rack',
            (v) => v <= 5 || 'Maximum is 5 racks',
          ],
        },
        widgets: [
          {
            type: 'text',
            name: 'name',
            label: 'Name',
            value: '',
            counter: 100,
            maxLength: 100,
            rules: [
              (v) => !!v || 'Name is required',
            ],
          },
          {
            type: 'number',
            name: 'temperature',
            label: 'Temperature',
            value: '',
            counter: 5,
            maxLength: 5,
            rules: [
              (v) => !!v || 'Temperature is required',
            ],
          },
          {
            type: 'number',
            name: 'noOfShelves',
            label: 'Number of Shelves',
            value: '',
            counter: 100,
            maxLength: 100,
            min: 1,
            max: 7,
            rules: [
              (v) => !!v || 'No of Shelves is required',
              (v) => Number.isInteger(Number(v)) || 'Must be a whole number',
              (v) => v >= 1 || 'Minimum is 1 shelf',
              (v) => v <= 7 || 'Maximum is 7 shelves',
            ],
          },
          // to be permanently removed later
          // {
          //   type: 'number',
          //   name: 'noOfRacks',
          //   label: 'Number of Racks',
          //   value: '',
          //   counter: 100,
          //   maxLength: 100,
          //   rules: [
          //     (v) => !!v || 'Number of Racks is required',
          //   ],
          // },
          // {
          //   type: 'number',
          //   name: 'noOfSlidingRacks',
          //   label: 'Number of Sliding Racks',
          //   value: '',
          //   counter: 100,
          //   maxLength: 100,
          //   rules: [
          //     (v) => !!v || 'Number of Sliding Racks is required',
          //   ],
          // },
          {
            type: 'anchor',
            id: 'freezer-ui-section',
          },
          {
            type: 'anchor',
            id: 'description-section',
          },
          {
            type: 'anchor',
            id: 'save-button-section',
          },
          // {
          //   type: 'button',
          //   btnType: 'submit',
          //   name: 'save',
          //   label: 'Save',
          //   color: 'primary',
          //   value: null,
          // },
        ],
      },
    };
  },
  created() {
    this.initializeForm();
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    async 'formData.widgets.2.value'(value) {
      const isValueChanged = this.displayShelf
        ? value === this.displayShelf
        : false;
      const isValidValue = value > 0 && value <= 7 && !isValueChanged;

      this.displayGenButton = isValidValue;

      if (isValidValue) {
        this.shelfNumber = value;
      }
    },
    // eslint-disable-next-line object-shorthand
    // async 'formData.noOfRacks.value'(value) {
    //   console.log('value of racks: ', value);
    // },
    displayShelf(newVal) {
      const currentLength = this.shelves.length;

      // ADD shelves
      if (newVal > currentLength) {
        for (let i = currentLength; i < newVal; i += 1) {
          this.shelves.push({
            shelfNo: i + 1,
            noOfColumn: 0,
            contents: [],
            isGeneratingColumn: false,
            generatedColumn: false,
          });
        }
      }

      // REMOVE shelves
      if (newVal < currentLength) {
        this.shelves = this.shelves.slice(0, newVal);
      }
    },
    displayRacks(newVal) {
      this.racks = Array.from(
        { length: newVal },
        (_, i) => ({
          rackNo: i + 1,
          noOfSlidingRacks: 0,
        }),
      );
    },
    freezer: {
      immediate: true,
      handler() {
        this.initializeForm();
      },
    },
  },
  methods: {
    onSave() {
      const hasInvalidRack = this.shelves.some((shelf) => shelf.contents.some(
        (content) => content.type?.toLowerCase() === 'rack'
        && !content.slidingRacksNo,
      ));

      if (hasInvalidRack) {
        // change this with other alert
        this.$snackbar.showBad({
          text: 'Sliding Racks is required for Rack type',
        });
        // alert('Sliding Racks is required for Rack type');
        return;
      }

      // && this.formSelectedTableMetadata.items.length > 0
      if (this.$refs.form.validate()) {
        const dataChanges = this.getFormDataJSON();
        dataChanges.shelves = this.shelves.map((shelf) => ({
          shelfNo: shelf.shelfNo,
          noOfColumn: shelf.noOfColumn,
          contents: shelf.contents,
        }));
        // dataChanges.boxNumbers = this.storeBoxes;
        dataChanges.description = this.formData.freezerDescription.value;
        const data = Object.assign(this.freezer || {}, dataChanges);
        // currently ongoing, shelves doesn't seem to push to backend
        // so checking the data may have the solution
        this.onSubmit(data);
      }
    },
    getFormDataJSON() {
      const data = FormService.dataAsJSON(this.formData);
      return data;
    },
    generateFreezerUi() {
      this.isGenerating = true;
      setTimeout(() => {
        this.displayShelf = this.shelfNumber;
        this.generatedUi = true;
        this.isGenerating = false;
      }, 1000);

      this.displayGenButton = false;
    },
    generateColumn(shelf) {
      shelf.isGeneratingColumn = true;

      setTimeout(() => {
        const currentLength = shelf.contents.length;
        const targetLength = Number(shelf.noOfColumn);

        // ADD columns
        if (targetLength > currentLength) {
          for (let i = currentLength; i < targetLength; i += 1) {
            shelf.contents.push({
              columnNo: i + 1,
              type: '',
              name: '',
              notes: '',
              slidingRacksNo: '',
            });
          }
        }

        // REMOVE columns
        if (targetLength < currentLength) {
          shelf.contents = shelf.contents.slice(0, targetLength);
        }

        shelf.generatedColumn = true;
        shelf.isGeneratingColumn = false;
      }, 1000);
    },
    getColumnIcon(type) {
      switch (type) {
        case 'Rack':
          return 'mdi-view-stream';

        case 'Box':
          return 'mdi-package-variant-closed';

        case 'Others':
          return 'mdi-dots-horizontal-circle-outline';

        case 'Empty':
          return 'mdi-close-circle-outline';

        default:
          return 'mdi-fridge-outline';
      }
    },

    getColumnColor(type) {
      switch (type) {
        case 'Rack':
          return 'primary';

        case 'Box':
          return 'orange';

        case 'Others':
          return 'purple';

        case 'Empty':
          return 'grey';

        default:
          return 'blue-grey';
      }
    },
    onStorageTypeChange(content) {
      content.name = '';
      content.notes = '';
      content.slidingRacksNo = '';
      // now on selecting the content should be inserted, and should be unique
      if (content.type.toLowerCase() === 'rack') {
        // display UI
      }
    },
    initializeForm() {
      if (!this.freezer) return;

      this.formData.model = this.freezer;

      this.formData.widgets.forEach((w) => {
        const widget = w;

        const getValue = (key) => {
          if (key?.includes('date')) {
            return new Date(this.freezer[key]);
          }

          return this.freezer[widget.name];
        };

        widget.value = getValue(widget.name);
      });

      this.formData.freezerDescription.value = this.freezer.description;

      if (this.freezer.shelves?.length) {
        this.shelves = [];
        this.shelves = this.freezer.shelves.map((shelf) => ({
          shelfNo: shelf.shelfNo,
          noOfColumn: shelf.noOfColumn,
          contents: shelf.contents || [],

          // UI-only fields
          isGeneratingColumn: false,
          generatedColumn: true,
        }));

        this.displayShelf = this.shelves.length;
        this.generatedUi = true;
      }
    },
    removeColumn(shelf, columnNo) {
      this.$confirmDialog.show({
        title: `Remove Column ${columnNo}`,
        text: `Are you sure you want to <b>remove Column ${columnNo}?</b> from <b>Shelf ${shelf.shelfNo}</b>`,
      }, async () => {
        // remove selected column
        shelf.contents = shelf.contents.filter(
          (content) => content.columnNo !== columnNo,
        );

        // re-number columns
        shelf.contents = shelf.contents.map((content, index) => ({
          ...content,
          columnNo: index + 1,
        }));

        // sync column count
        shelf.noOfColumn = shelf.contents.length;
      });
    },
    // getShelfDetails(shelf) {
    //   // move this to other function that generates the shelf
    //   const { shelfNo } = shelf;
    //   const exists = this.racksInput.some((ri) => ri.shelfNo === shelfNo);
    //   if (shelf.type === 'specimen' && !exists) {
    //     this.racksInput.push({
    //       name: `rackInput${shelfNo}`,
    //       shelfNo,
    //       value: '',
    //     });
    //   }
    // },
    // generateRacks(input) {
    //   this.displayRacks = input.value;
    //   setTimeout(() => {
    //     this.shelves.forEach((sh, i) => {
    //       if (sh.shelfNo === input.shelfNo) {
    //         this.shelves[i].racks = this.racks;
    //       }
    //     });
    //   }, 1000);
    // },
    // addProjectCode() {
    //   // adds multiple project code
    //   this.countAddedBox += 1;
    //   const setBoxes = {
    //     boxNumber: {
    //       name: `boxNumber${this.countAddedBox}`,
    //       value: '',
    //     },
    //     col: {
    //       name: `col${this.countAddedBox}`,
    //       value: '',
    //     },
    //     row: {
    //       name: `row${this.countAddedBox}`,
    //       value: '',
    //     },
    //   };
    //   this.storeBoxes.push(setBoxes);
    // },
  },
};
</script>
<style scoped>
.generate-button {
  display: flex;
  justify-content: center; /* Horizontal centering */
  align-items: center;     /* Vertical centering */
  margin-bottom: 20px;
  margin-top: -10px;
}
.freezerUi {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 20px;
}

.shelf-wrapper {
  border: 2px solid #cbd5e1;
  border-radius: 16px;
  padding: 20px;
  background: #f8fafc;
}

.shelf-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 12px;
}

.shelf-title {
  font-size: 20px;
  font-weight: bold;
  color: #334155;
}

.shelf-controls {
  gap: 12px;
  align-items: center;
}

.column-input {
  max-width: 120px;
}

.shelf-body {
  display: grid;
  gap: 12px;
  min-height: 220px;
}

.freezer-column {
  background: linear-gradient(
    to bottom,
    #eff6ff,
    #dbeafe
  );

  border: 2px solid #bfdbfe;
  border-radius: 14px;

  min-height: 220px;

  display: flex;
  flex-direction: column;

  cursor: pointer;

  transition: all 0.2s ease;
  overflow: hidden;
}

.freezer-column:hover {
  transform: translateY(-4px);
  border-color: #1976d2;
  box-shadow: 0 8px 20px rgba(25, 118, 210, 0.2);
}

.column-label {
  padding: 12px;
  font-weight: 700;
  background: rgba(255,255,255,0.5);
  border-bottom: 1px solid #bfdbfe;

  display: flex;
  align-items: center;
  justify-content: space-between;
}
.column-select {
  width: 100%;
  padding: 0 16px 16px;
}

.column-content {
  flex: 1;

  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  gap: 12px;
}

.freezer-column {
  position: relative;
}

.column-type {
  font-size: 16px;
  font-weight: 700;
  color: #334155;
  margin-bottom: 12px;
}

.scrollable-textarea textarea {
  max-height: 120px;
  overflow-y: auto !important;
}

.column-form-wrapper {
  width: 100%;
  padding: 14px;
  border-radius: 12px;

  background: rgba(255, 255, 255, 0.65);

  border: 1px solid rgba(255,255,255,0.7);

  backdrop-filter: blur(6px);

  display: flex;
  flex-direction: column;

  gap: 14px;
}

.column-form-header {
  display: flex;
  align-items: center;
  gap: 10px;

  padding-bottom: 8px;

  border-bottom: 1px solid #dbeafe;
}

.column-form-title {
  font-size: 16px;
  font-weight: 700;
  color: #334155;
}

.column-form {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

/* Better textarea scrolling */
.scrollable-textarea textarea {
  max-height: 120px;
  overflow-y: auto !important;
}

/* Better spacing inside column */
.column-content {
  width: 100%;

  flex: 1;

  display: flex;
  flex-direction: column;

  justify-content: space-between;
  align-items: stretch;

  gap: 14px;

  padding: 14px;
}

</style>
